<div class="modal">
    <div class="modal-header">
        <div class="modal-title"></div>
        <button class="modal-close" (click)="close()">
            <app-icon [key]="'clear'" />
        </button>
    </div>
    <div class="modal-content">
        <i class="material-symbols-outlined filled icon">check_circle</i>

        <span class="message">
            {{ 'comp.form-submitted-popup.message' | translate }}
        </span>

        <div class="btn-row">
            <button class="btn btn-secondary" (click)="download()">
                <app-icon [icon]="'reply'" [style]="'outlined'" [mirrored]="true" />
                <span>{{ 'comp.form-submitted-popup.download' | translate }}</span>
            </button>
        </div>
    </div>
</div>
